// extracted by mini-css-extract-plugin
export var measureBox = "_aj-0";